import type { FC, SVGProps } from 'react';

const FilePercentage: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.44198 25.8384C2.89649 18.6506 1.21564 7.66446 0.65603 4.11301C0.557034 3.48476 1.00324 2.90614 1.63642 2.84625C7.34507 2.30626 16.5619 1.84206 18.299 1.51878L22.3742 4.4979L24.7467 23.2054C24.8237 23.8126 24.3939 24.3673 23.7867 24.4443L4.69655 26.8654C4.06111 26.946 3.49045 26.4771 3.44198 25.8384Z"
      fill="#F6F3FE"
      stroke="#291547"
      strokeWidth="0.9975"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.52434 25.6173C4.90663 18.0391 4.60634 6.34403 4.4923 2.56126C4.47212 1.89208 5.01468 1.34708 5.68409 1.3574C11.7294 1.45064 21.5111 1.44349 23.368 1.33594L27.1209 5.83947V25.6893C27.1209 26.3336 26.5986 26.8559 25.9542 26.8559H5.69842C5.02419 26.8559 4.49037 26.2907 4.52434 25.6173Z"
      fill="#F6F3FE"
      stroke="#291547"
      strokeWidth="1.05"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.107 10.1261C20.312 9.92153 20.6438 9.92146 20.8487 10.1261C21.0538 10.3311 21.0537 10.6639 20.8487 10.869L11.5177 20.2023C11.3127 20.4073 10.9799 20.4073 10.7748 20.2023C10.5698 19.9973 10.5699 19.6645 10.7748 19.4595L20.107 10.1261Z"
      fill="#291547"
    />
    <path
      d="M20.4747 18.4974C20.4747 19.2338 19.8779 19.8307 19.1417 19.8307C18.4054 19.8307 17.8086 19.2338 17.8086 18.4974C17.8086 17.761 18.4054 17.1641 19.1417 17.1641C19.8779 17.1641 20.4747 17.761 20.4747 18.4974Z"
      fill="#291547"
    />
    <path
      d="M13.8107 11.8314C13.8107 12.5678 13.2138 13.1647 12.4776 13.1647C11.7414 13.1647 11.1445 12.5678 11.1445 11.8314C11.1445 11.095 11.7414 10.498 12.4776 10.498C13.2138 10.498 13.8107 11.095 13.8107 11.8314Z"
      fill="#291547"
    />
    <path
      d="M23.0191 0.885742L27.5226 5.95629C27.5226 5.95629 22.9301 6.48575 21.934 5.48962C20.9379 4.4935 23.0191 0.885742 23.0191 0.885742Z"
      fill="#291547"
    />
  </svg>
);
export default FilePercentage;
